import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error Library not migrated yet
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import styled from 'styled-components';
import { getAvatarUrl } from '../avatarQueries';
const Avatar = styled(UIAvatar).withConfig({
  displayName: "AvatarViewer__Avatar",
  componentId: "h70s5h-0"
})(["box-sizing:border-box;"]);
export const AvatarViewer = ({
  avatarHash,
  email,
  className = '',
  size = 'xl',
  displayName,
  type
}) => {
  return /*#__PURE__*/_jsx(Avatar, {
    className: className,
    displayName: displayName,
    hubSpotUserEmail: email,
    size: size,
    src: avatarHash && getAvatarUrl(avatarHash),
    type: type
  });
};